export default {
  ADDRESS: 'Address',
  BIRTHPLACE: 'Birthplace',
  IDENTIFICATION_BIRTH_PLACE: 'Identification Birthplace',
  BIRTHPLACE_WITHOUT_COUNTY: 'Birthplace without County',
  INTERNATIONAL_CITY_COUNTRY_ONLY: 'International city country only',
  COUNTRY: 'Country',
  US_CITY_STATE_INTERNATIONAL_CITY: 'US City, State, International city',
  US_CITY_STATE_INTERNATIONAL_CITY_COUNTRY: 'US City, State, International city country',
  US_CITY_STATE_COUNTY_INTERNATIONAL_CITY_COUNTRY: 'US City, State, County, International city country',
  STATE: 'State',
  CITY_STATE: 'City, State',
  STREET_CITY_COUNTRY: 'Street, City, Country',
  CITY_COUNTRY: 'City, Country',
  US_CITY_STATE_ZIP_INTERNATIONAL_CITY: 'US City, State, Zipcode International city',
  CITY_STATE_COUNTRY: 'City, State, Country',
  US_ADDRESS: 'US Address',
  STREET_CITY: 'Street, City',
  OFFENSE: 'Offense',
};
